import React, { useState } from "react";
import "./login.css";
import { Link } from "react-router-dom";
import lockimg from "../../assets/login/image 3037.svg";
import logo from "../../assets/login/Group 1000008451 (1) 1.svg";

function Login() {
  const [data, setData] = useState("login");

  function signup(ev) {
    console.log(ev);
    setData(ev);
  }

  console.log(data);
  return (
    <div className="outer">
      <div className="login_outer">
        <div className="login_outer_2">
          <div className="login_left">
            <form action="">
              <div className="input_items">
                <h1>LOGIN</h1>
                <label htmlFor="">Organization Id</label>
                <input type="text"required />
                <label htmlFor="">User Id</label>
                <input type="text" required/>
                <label htmlFor="">Password</label>
                <input type="password" required/>
                <div className="login_buttons">
                  <button>LOGIN</button>
                </div>
              </div>
            </form>
          </div>
          <div className="login_right_images">
            <img src={lockimg} alt="lockimg" className="img1" />
            <img src={logo} alt="logo" className="img2" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
